import { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Backdrop } from './Backdrop'
import { useKeyPress } from 'ahooks'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.lg};
`

const Content = styled.div`
  position: relative;
  z-index: 101;
  background: ${({ theme }) => theme.colors.common.white};
  width: 320px;
  max-width: 100%;
  text-align: center;
  border-radius: 0.5em;
  box-shadow:
    0 3px 3px -2px rgba(0, 0, 0, 0.2),
    0 3px 4px 0 rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);
`

export const ModalDialog: FC<PropsWithChildren<{ opened: boolean; onClose: () => void }>> = ({
  opened,
  onClose,
  children,
}) => {
  useKeyPress('esc', () => {
    onClose()
  })

  if (!opened) {
    return null
  }

  return (
    <Container>
      <Content>{children}</Content>

      <Backdrop
        onClick={() => {
          onClose()
        }}
      />
    </Container>
  )
}

export const ModalDialogTitle = styled.h2`
  margin: 0 0 8px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`

export const ModalDialogButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ModalDialogBody = styled.div`
  padding: 1rem;
`
